export default __webpack_public_path__ + "static/media/Logo.09637a96.png";